import { render, staticRenderFns } from "./modal_actualizar_material_aseo.vue?vue&type=template&id=2b61b56a&"
import script from "./modal_actualizar_material_aseo.vue?vue&type=script&lang=js&"
export * from "./modal_actualizar_material_aseo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports